import Steps from "./Steps";
import {STEP_MODEL} from "../../Model/HomeModel";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 19 de 05 de 2026
 */

const StepsForgotPassword = ({ t, activeStep, stepModel, email, setEmail, handleEmailChange, handleKeyDown,handleValidateOtp,
                                 isValidEmail, emptyFields, handleEmailSend,canResendOtp, minutes, seconds,otp,
                                 setOtp,handleResendOtp,handleSavePassword, password, setPassword, confirmPassword,
                                 setConfirmPassword, setTouched, barClass, allPassed, ruleList, ruleClass, passwordsMatch,
                                 canSave, setIsValidOtp, isValidOtp,secretModal, setSecretModal,
                                 secretKey, setSecretKey,handleSelectFlow
}) => {

    const { renderEmailOtp, renderAppOtp,renderChoice } = Steps({
        activeStep, email, setEmail, handleEmailChange, handleKeyDown, handleValidateOtp,handleResendOtp,
        isValidEmail, emptyFields, t, handleEmailSend , canResendOtp,minutes,seconds,otp,stepModel,
        setOtp,handleSavePassword, password, setPassword, confirmPassword, handleSelectFlow,
        setConfirmPassword, setTouched, barClass, allPassed, ruleList, ruleClass, passwordsMatch,
        canSave, setIsValidOtp, isValidOtp,secretModal, setSecretModal, secretKey, setSecretKey
    });

    const renderStepContent = () => {
        switch (stepModel?.NAME) {
            case STEP_MODEL.CHOICE.NAME:
                return renderChoice();
            case STEP_MODEL.EMAIL.NAME:
                return renderEmailOtp();
            case STEP_MODEL.APP.NAME:
                return renderAppOtp();
            default:
                return null;
        }
    };

    return <>{renderStepContent()}</>;
};

export default StepsForgotPassword;
